<template>
  <div class="match-block">
    <font-awesome-icon :icon="['fas','long-arrow-alt-down']" size="1x" class="has-text-danger"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLongArrowAltDown } from '@fortawesome/pro-solid-svg-icons';

library.add(faLongArrowAltDown);

export default {
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .fa-long-arrow-alt-down
    color: red
</style>
